import React, { Fragment } from "react";

import { Form, Input } from "antd";

import ModalComponent from "@/components/modal";
import ButtonComponent from "@/components/button/Button";

import "@/styles/pages/auth/set-new-password.scss";
import { useDispatch, useSelector } from "react-redux";
import { getIsLoggedIn, getToken, setCurrentForm, setModalOpen } from "@/reducers/commonSlice";
import { changePassword } from "@/services/accounts/createNewPassword";
import useTriggerNotification from "@/hooks/useTriggerNotification";

const SetNewPassword = ({ isOpen = false }) => {
  const dispatch = useDispatch();
  const token = useSelector(getToken);
  const isLoggedIn = useSelector(getIsLoggedIn);
  const { trigger, element } = useTriggerNotification();

  const handleSubmit = (value) => {
    console.log(value, "value");
    changePassword(
      {
        password: value.password,
        token: token,
      },
      true
    )
      .then((response) => {
        console.log(response);
        if (isLoggedIn) {
          dispatch(setModalOpen(false));
        } else {
          dispatch(setCurrentForm("signIn"));
        }
        trigger({
          type: "success",
          message: "Password updated successfully",
        });
      })
      .catch((error) => console.log(error));
  };
  return (
    <Fragment>
      {element}
      <ModalComponent buttonLabel="Set New Password" isOpen={isOpen} className="onboarding-modal">
        <div className="forgot-password-modal">
          <div className="heading title-h5">
            Set a new <br /> <span className="title-h5-1">password!</span>
          </div>
          <div className="form">
            <Form
              name="register"
              initialValues={{ remember: true }}
              layout="vertical"
              onFinish={handleSubmit}
            >
              <Form.Item
                label="Password"
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Password must be at least 8 characters long.",
                  },
                  {
                    min: 8,
                    message: "Password must be at least 8 characters long.",
                  },
                ]}
              >
                <Input.Password placeholder="Enter new password" />
              </Form.Item>

              <Form.Item>
                <div className="button">
                  <ButtonComponent label="Set New Password" varient="primary" htmlType="submit" />
                </div>
              </Form.Item>
            </Form>
            {!isLoggedIn ? (
              <div className="signup body-b4-1">
                <span onClick={() => dispatch(setCurrentForm("signIn"))}>Back to Login</span>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </ModalComponent>
    </Fragment>
  );
};

export default SetNewPassword;
